import store from '@/store/index'

export default {
  // Do not allow guest users to access auth routes
  //
  isLoggedIn: (to, from, next) => {
    if (store.getters.isUserLoggedIn) {
      next()
    } else {
      localStorage.setItem('previousUrl', process.env.VUE_APP_SERVER_BASE_URL+'/buy'+to.fullPath)
      next(`?authModal=true&prev=${to.fullPath}`)
    }
  },

  // Do not allow logged-in users to access guest routes
  //
  isGuest: (to, from, next) => {
    if (store.getters.isUserLoggedIn) {
      next({ name: 'Home' })
    } else {
      next()
    }
  }
}